<template>
  <draggable
    class="dragArea"
    tag="ul"
    :list="structures"
    :group="{ name: 'g1' }"
    animation="500"
    easing="cubic-bezier(0.445, 0.05, 0.55, 0.95)"
    ghost-class="ghost"
    @change="onChange"
    :disabled="dragDisableFlg"
  >
    <li v-for="el in structures" :key="el.dragId" class="">
      <div class="ghost__item">
      </div>
      <a class="dragAreaCursor__text d-flex justify-content-start align-items-center">
        <span>
          {{$t('品番')}}:&nbsp;{{ el.productCode }}
          <template v-if="el.productVersion">
            /&nbsp;{{ el.productVersion }}
          </template>
          <br>
          {{$t('品名')}}:&nbsp;{{ el.productName }}<br>
          {{$t('数量')}}:&nbsp;{{el.quantity}}
        </span>
        <button
            type="button"
            class="btn btn-light create-btn ml-2"
            @click="detailProduct(el)"
            v-if="!dragDisableFlg"
          >{{ $t('製品詳細') }}</button>
        <button
            type="button"
            class="btn btn-success create-btn ml-2"
            @click="addStructure(el)"
            v-if="!dragDisableFlg"
          >{{ $t('配下に製品を追加') }}</button>
        <font-awesome-icon v-if="!dragDisableFlg" @click="removeStructure(el)" :icon="['fas', 'times-circle']" class="ml-2" />
      </a>
      <nested-draggable class="item-box"
      :structures="el.structures"
      @removeStructure="removeStructure($event)"
      @addStructure="addStructure($event)"
      @detailProduct="detailProduct($event)"
       />
    </li>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'
export default {
  props: {
    structures: {
      type: Array,
    },
  },
  components: {
    draggable,
  },
  methods: {
    removeStructure(item) {
      this.$emit('removeStructure', item)
    },
    addStructure(item) {
      this.$emit('addStructure', item)
    },
    detailProduct(item) {
      this.$emit('detailProduct', item)
    },
    onChange() {
      this.$emit('register')
    },
  },
  name: 'nested-draggable',
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
      isMyoridge: 'auth/isMyoridge',
    }),
    dragDisableFlg() {
      return this.isMyoridge
    },
  },
}
</script>

<style lang="scss" scoped>
.dragArea {
  // min-height: 20rem;
  // padding: 0;
  // margin: 1rem;
  // border-radius: 3px;
  // .dragAreaCursor__icon {
  //   display: none;
  // }
  // .dragArea {
  //   // min-height: 10rem;
  //   margin-left: 0;
  //   margin-right: 0;
  //   .dragAreaCursor__icon {
  //     display: block;
  //   }
  // }
}
.ghost {
  position: relative;
  &::before {
    //border: none;
  }
  .dragArea__item {
    // border: none;
  }
  .ghost__item {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border:1px dashed #ccc;
    background-color: #fff;
    z-index: 1;
  }
}
.dragArea__item {
  padding-left: 20px;
  // margin: 1rem;
  .handle {
    cursor: move;
  }
}
.fa-times-circle {
  color: red;
  cursor: pointer;
}
.fa-plus-circle {
  color: blue;
  cursor: pointer;
}
.dragAreaCursor {
  cursor: move;
  // transition: .5s;
  // width: 5rem;
  position: relative;
  // border-right: 1px dashed #bdbdbd;
  // &:hover {
  //   background-color: rgb(242, 255, 240);
  //   .dragAreaCursor__icon {
  //     opacity: 1;
  //   }
  // }
}
.dragAreaCursor__icon {
  transition: .5s;
  font-size: 2.2rem;
  width: 30px;
  opacity: .3;
}
.dragAreaCursor__text {
  font-size: 1.6rem;
  cursor: move;
  padding: 1rem;
  border: 1px dotted #ccc;
  background-color: #f9f9f9;
  // letter-spacing: .5rem;
  // margin: 2rem auto 0;
}
.box-title {
  font-size: 12px;
  font-weight: bold;
  color: #666;
  margin-bottom: 4px;
}
// .item-box {
//   margin-top: 5px;
// }
</style>

<style lang="scss" scoped>
// .dragArea {
//   min-height: 20rem;
//   padding: 0;
//   background-color: #f3f3f3;
//   border: 1px dashed #bdbdbd;
//   margin: 1rem;
//   border-radius: 3px;
//   // display: flex;
//   // flex-flow: column;
//   // justify-content: center;
//   // align-items: center;
//   // outline: 1px dashed;
//   .dragArea {
//     min-height: 10rem;
//     margin-left: 0;
//     margin-right: 0;
//   }
// }
// .ghost {
//   position: relative;
//   .dragArea__item {
//     border: none;
//   }
//   .ghost__item {
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 100%;
//     background-color: #fafafa;
//     z-index: 1;
//   }
// }
// .dragArea__item {
//   border: 1px dashed #bdbdbd;
//   background-color: #fafafa;
//   margin: 1rem;
//   .handle {
//     cursor: move;
//   }
//   .fa-times-circle {
//     color: red;
//   }
// }
// .dragAreaCursor {
//   cursor: move;
//   transition: .5s;
//   width: 5rem;
//   position: relative;
//   border-right: 1px dashed #bdbdbd;
//   &:hover {
//     background-color: rgb(242, 255, 240);
//     .dragAreaCursor__icon {
//       opacity: 1;
//     }
//   }
// }
// .dragAreaCursor__icon {
//   transition: .5s;
//   font-size: 2.2rem;
//   opacity: .3;
//   position: absolute;
//   top: 1rem;
//   left: 50%;
//   transform: translateX(-50%);
// }
// .dragAreaCursor__text {
//   font-size: 1.4rem;
//   writing-mode: vertical-rl;
//   text-orientation: upright;
//   letter-spacing: .5rem;
//   margin: 2rem auto 0;
// }
// .box-title {
//   font-size: 12px;
//   font-weight: bold;
//   color: #666;
//   margin-bottom: 4px;
// }
// .item-box {
//   margin-top: 5px;
// }
</style>
